import vue from 'vue';

// 商品曝光埋点
vue.directive('gioShow',{
  bind:function(el, binding, vnode){
    let data = vnode.data.attrs;
    gio('track','flowExposure',{positonName_var:data.item.itemName,sort_var:data.item.categoryName,position_var:data.index})
  }
})
// 发现曝光埋点
vue.directive('discovergio',{
  bind:function(el,binding,vnode){
    let data = vnode.data.attrs;
    gio('track','flowDiscover',{dsicover_name_var:data.item.title,discover_position_var:data.index})
  }
})
// 商品曝光埋点
vue.directive('activityShow',{
  bind:function(el, binding, vnode){
    console.log("商品曝光埋点-moduleExpore_var--");
    let data = vnode.data.attrs;
    gio('track','moduleExpore_var',{secondPageID_var: String(data.activityId), entryType_vara:data.type, entryType_floor_var: String(data.sort), position_var:String(data.index), sort_var:'', positonName_var:data.itemId})
  }
})

vue.directive('isNoAppShare',{
  bind:function(el,binding,vnode){
    let appversion = window.tools.getversion();  //更具版本判断是否在APP 
    const isInWechatMP = () => {   // 在判断是否是在小程序
      if(appversion){
        return true
      }
      return (navigator.userAgent.match(/micromessenger/i) && navigator.userAgent.match(/miniprogram/i)) || window.__wxjs_environment === 'miniprogram' || navigator.userAgent.match(/UnionPay/i);
    };
    if(!isInWechatMP()){
      if(vnode.data.attrs && vnode.data.attrs.show) return
      el.style="display:block";
    }
  }
})